export const INSPECTED_WITHIN_DAYS = 30;
